// Helper function to determine availability status
const getAvailabilityStatus = (seatsTaken, totalSeats) => {
  // Handle cases with no seats or division by zero
  if (totalSeats === 0 || seatsTaken >= totalSeats) {
    return {
      text: 'Full',
      smallText: 'Full',
      color: 'text-performance-pulse', // Red for full
      icon: '❌',
    };
  }

  const percentage = (seatsTaken / totalSeats) * 100;

  if (percentage >= 80) {
    return {
      text: 'Almost Full',
      smallText: 'Few',
      color: 'text-performance-energy', // Orange for almost full
      icon: '⚠️',
    };
  }

  return {
    text: 'Spaces Available',
    smallText: 'Many',
    color: 'text-emerald-300', // Emerald for available
    icon: '✅',
  };
};

// Your updated component
const SessionPlacesCard = ({ seatsTaken, availableSeats, small = false}) => {
  const availability = getAvailabilityStatus(seatsTaken, availableSeats);

  return (
    <div className="glass-luxury rounded-lg p-3 border border-emerald-600/20 bg-gradient-to-br from-luxury-slate/40 to-luxury-obsidian/60">
      <div className="text-xs text-emerald-300 uppercase mb-1 font-display">
       {small ? <span>Places</span> : <span>Availability</span>}
      </div>
      <div className={`flex items-center gap-2 text-lg font-display font-bold ${availability.color}`}>
        <span>{small ? availability.smallText : availability.text}</span>
      </div>
        {/* Optional: Add a small message for better UX */}
        { !small ? (
            <div className="text-xs text-emerald-600/60 h-4 mt-1 font-body">
                {availability.text !== 'Spaces Available' && 'Few spots remaining'}
            </div>
        ) : null}
    </div>
  );
};

export default SessionPlacesCard;